import { Workspace } from '../../interface/Workspace';
import { WORKSPACE_SELECTED } from './types';

export const setWorkspaceSelected = (workspace: Workspace | null) => ({
  type: WORKSPACE_SELECTED,
  payload: workspace,
});
